import { render } from "./Idea.vue?vue&type=template&id=7baaae96"
import script from "./Idea.vue?vue&type=script&lang=js"
export * from "./Idea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/lotties/Idea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7baaae96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7baaae96', __exports__)) {
    api.reload('7baaae96', __exports__)
  }
  
  module.hot.accept("./Idea.vue?vue&type=template&id=7baaae96", () => {
    api.rerender('7baaae96', render)
  })

}


export default __exports__